// This file is automatically generated by AutoIndexPlugin. Do not edit manually.
import './ajax-action';
import './application';
import './charts';
import './code-editor-display';
import './color-field';
import './confirm';
import './copy-to-clipboard';
import './date-time-diff-for-humans';
import './ea-filters';
import './entry-comparison';
import './file';
import './filter-form';
import './form-outline';
import './form';
import './general-settings';
import './lightbox';
import './login-form';
import './loyalty-scoring';
import './loyalty-values';
import './mail-stats-chart';
import './prize-stock-update';
import './progress-bar';
import './receipt-lightbox';
import './reject-form';
import './required-value';
import './sortable';
import './stages';
import './sticky-scrollbar';
import './ui';
import './user-prizes';
import './verify-receipt-form';
